var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.307 10.523c-.508-.421-.795-.991-.86-1.71h1.449c.043.385.191.687.446.905.254.218.588.326 1.002.326.393 0 .705-.094.941-.283a.902.902 0 0 0 .354-.74.66.66 0 0 0-.363-.615c-.245-.135-.653-.267-1.226-.398l-.066-.011c-.776-.175-1.352-.412-1.726-.714-.374-.301-.561-.705-.561-1.214 0-.261.065-.506.196-.735.13-.229.319-.43.566-.604-.507-.327-.762-.81-.762-1.448 0-.414.105-.782.316-1.105s.512-.574.904-.751.846-.267 1.361-.267c.755 0 1.358.187 1.808.561.451.374.723.909.816 1.606H7.51c-.045-.327-.174-.585-.387-.774-.215-.189-.496-.283-.845-.283-.334 0-.61.087-.828.262s-.326.387-.326.642c0 .261.112.45.337.566.233.138.628.265 1.187.381.85.182 1.469.425 1.857.729.389.305.582.726.582 1.263 0 .495-.236.94-.707 1.339.238.16.416.356.533.588.116.233.175.521.175.861 0 .436-.109.824-.326 1.166-.219.341-.535.607-.953.8s-.91.289-1.476.289c-.842 0-1.518-.211-2.026-.632zM5.2 6.298c.102.109.26.204.474.283.214.08.536.167.964.262.437.102.7.171.796.207a.964.964 0 0 0 .305-.697.713.713 0 0 0-.152-.468 1.184 1.184 0 0 0-.453-.283 8.843 8.843 0 0 0-.888-.262l-.294-.076a3.914 3.914 0 0 1-.545-.142c-.247.203-.37.443-.37.719 0 .181.054.334.163.457z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLegal);
export default __webpack_public_path__ + "static/media/dashboard-legal.921c44b04fd91c6291b204bb9f5e3680.svg";
export { ForwardRef as ReactComponent };